import { useEffect } from "react";

function AfterHE() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const msisdn = params.get("msisdn");
    const offerCode = localStorage.getItem("offerCode");

    if (!msisdn || !offerCode) {
      window.location.href = "/signin?fallback=true";
      return;
    }

    const url =
      "http://ghanagameium.com/Redirect?OfferCode=" +
      offerCode +
      "&mobileNumber=" +
      msisdn +
      "&redirectUrl=http://ghanagameium.com/api/cgw/callback";

    window.location.replace(url);
  }, []);

  return <div className="text-center mt-10">Processing...</div>;
}

export default AfterHE;